import React, { FunctionComponent, SVGProps } from 'react'

export const IconLoader: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="47"
      height="48"
      viewBox="0 0 47 48"
      fill="none"
      stroke="#0062CA"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 3C26.7918 3 30.5128 4.02664 33.7682 5.97094C37.0235 7.91525 39.6917 10.7047 41.4895 14.0432C43.2873 17.3816 44.1477 21.1446 43.9793 24.9326C43.8109 28.7207 42.62 32.3924 40.533 35.5582C38.4461 38.724 35.5409 41.2657 32.1259 42.9134C28.7109 44.5612 24.9134 45.2536 21.1366 44.9172C17.3598 44.5807 13.7445 43.2279 10.6745 41.0024C7.60455 38.7769 5.19442 35.7617 3.69993 32.2769"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
